/**用户模块 */
import request from '../request/http';
/**获取用户详情 */
export function QueryUserInfo(){
    return request({
        url: '/sp/user/getUserDetail',
        method: 'post',
    })
}
/**分页查询用户审核记录 */
export function QueryNoExamineUser(data){
    return request({
        url: '/sp/user/pageQueryUserAudit' ,
        method: 'post',
        data
    })
}
/**审核用户 */
export function UserExamine(data){
    return request({
        url: '/sp/user/userAudit' ,
        method: 'post',
        data
    })
}
/**用户信息修改 */
export function EditBaseInfo(data){
    return request({
        url: '/sp/user/update',
        method: 'post',
        data
    })
}
/**用户申请认证 */
export function RealName(data){
    return request({
        url: '/sp/user/userApplyAuth',
        method: 'post',
        data
    })
}
/**获取用户数据统计 */
export function GetUserDataStatistics(data){
    return request({
        url: '/sp/user/getUserDataStatistics',
        method: 'post',
        data
    })
}
/**新增用户 */
export function AddUser(data){
    return request({
        url: '/sp/user/addUser',
        method: 'post',
        data
    })
}
/**修改用户 */
export function Update(data){
    return request({
        url: '/sp/user/update',
        method: 'post',
        data
    })
}
/**删除用户 */
export function DelUser(data){
    return request({
        url: '/sp/user/delUser',
        method: 'post',
        data
    })
}
/**分页查询用户信息 */
export function UserPageList(data){
    return request({
        url: '/sp/user/pageList',
        method: 'post',
        data
    })
}
/**获取内置业务角色 */
export function GetBusinessRole(){
    return request({
        url: '/sp/user/getBusinessRole',
        method: 'post',
    })
}
/**下载模板 */
export function DownloadUserTemplate(){
    return request({
        url: '/sp/user/downloadUserTemplate',
        responseType: 'arraybuffer',
        method: 'post',
    })
}
/**导入用户数据 */
export function ImportUser(data){
    return request({
        url: '/sp/user/importUser',
        method: 'post',
        data
    })
}